/** @jsx jsx */
import loadable from '@loadable/component'
import { jsx } from 'theme-ui'

import * as st from './styles'

const Trustpilot = loadable(() => import('@uswitch/ev-components/lib/components/elements/widget-html/trustpilot'))
const TrustpilotHorizontal = loadable(() =>
  import('@uswitch/ev-components/lib/components/elements/widget-html/trustpilot-horizontal')
)
const TrustpilotMicro = loadable(() =>
  import('@uswitch/ev-components/lib/components/elements/widget-html/trustpilot-micro')
)
const SocialSharing = loadable(() => import('@uswitch/ev-components/lib/components/compounds/social-sharing'))

const WidgetHtmlWrapper = ({ html, widgetId, options }) => {
  switch (widgetId) {
    case 'socialSharing':
      return <SocialSharing {...options} />
    case 'trustpilot':
      return <Trustpilot options={options} />
    case 'trustpilotCenter':
      return <Trustpilot options={options} alignment='center' />
    case 'trustpilotHorizontal':
      return (
        <div sx={st.trustpilotHorizontalWrapperStyles}>
          <TrustpilotHorizontal options={options} />
        </div>
      )
    case 'trustpilotMicroCenter':
      return <TrustpilotMicro options={options} alignment='center' />
    case 'trustpilotMicroLeft':
      return <TrustpilotMicro options={options} alignment='left' />
    default:
      return <div dangerouslySetInnerHTML={{ __html: html }} sx={{ marginTop: 'md' }} />
  }
}

export default WidgetHtmlWrapper
